// Maps a market/event's initial LP seed (internal units) to its tier chip.
const SEED_TIERS: Record<number, { name: string; amount: string; icon: string; cls: string }> = {
  1000:  { name: 'Bronze',  amount: '100K', icon: '🥉', cls: 'bg-orange-100 dark:bg-orange-950/60 text-orange-800 dark:text-orange-400' },
  2500:  { name: 'Silver',  amount: '250K', icon: '🥈', cls: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300' },
  5000:  { name: 'Gold',    amount: '500K', icon: '🥇', cls: 'bg-yellow-100 dark:bg-yellow-950/60 text-yellow-700 dark:text-yellow-400' },
  10000: { name: 'Diamond', amount: '1M',   icon: '💎', cls: 'bg-cyan-100 dark:bg-cyan-950/60 text-cyan-700 dark:text-cyan-300' },
}

export default function SeedBadge({ seed }: { seed: number | null | undefined }) {
  if (!seed) return null
  const tier = SEED_TIERS[Math.round(seed)]
  if (!tier) return null
  return (
    <span
      title={`${tier.name} tier — 🧀${Math.round(seed * 100).toLocaleString('en-US')} initial seed`}
      className={`text-xs font-semibold px-2 py-0.5 rounded-full ${tier.cls}`}
    >
      {tier.icon} {tier.amount}
    </span>
  )
}
